import React from 'react';
import { FormSection } from '@atlaskit/form';
import { useIntl } from '@atlassian/jira-intl';
import { DAYS_OF_THE_WEEK } from '../../../../../common/ui/constants.tsx';
import { DayWithHours } from './day-with-working-times';
import type { DefaultWorkingTimes } from './day-with-working-times/state/types.tsx';
import messages from './messages';

export type WorkingTimes = {
	[key: string]: DefaultWorkingTimes | undefined;
};

type Props = {
	workingTimes: WorkingTimes;
};

export const WorkWeekView = ({ workingTimes }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<>
			{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
			<h2> {formatMessage(messages.workWeek)} </h2>
			<FormSection>
				<p>{formatMessage(messages.openTip)}</p>
				{DAYS_OF_THE_WEEK.map((day) => (
					<DayWithHours key={day} day={day} defaultWorkingTimes={workingTimes[day]} />
				))}
			</FormSection>
		</>
	);
};

export const WorkWeek = WorkWeekView;
